








































































































































































import Vue from 'vue';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import MStoreFormSelect from '@/components/shared/MStoreFormSelect.vue';
import { DocumentTypeModel, CabinetReferenceModel, DocuSignSettingsModel, DocuSignSettingsConfigurationModel, DocuSignSettingsSearchModel, ValueType } from '@/types';
import { DocuSignConfigurationService } from '@/services/docuSign/DocuSignConfigurationService';
import SnotifyConfiguration from '@/classes/SnotifyConfiguration';
import { FormFieldValidation, confirmationHelper } from '@/mixins';
import { ValidationModel } from '@/types/models/validation';
export default Vue.extend({
  name: 'DocusignSettings',
  mixins: [FormFieldValidation, confirmationHelper],
  data() {
    return {
      isLoading: false,
      isSpinner: false,
      hasError: false,
      settings: {} as DocuSignSettingsModel,
      documentTypes: [] as DocumentTypeModel[],
      submitIsLoading: false,
      documentTypeId: null as number | null
    };
  },
  methods: {
    async onCancel(this: any, dirty: boolean) {
      try {
        const hasUnsavedChangesToKeep: boolean = await this.hasUnsavedChangesToKeepAsync(this.$bvModal, dirty);
        if (hasUnsavedChangesToKeep) {
          return;
        }
        this.setApplicationDirty(false);
        await this.getData(this.documentTypeId);
      } catch (error) {
        this.$log('failed to confirm unsaved changes');
        return false;
      }
    },
    async onSubmit(this: any) {
      this.hasError = false;
      try {
        const isValid = await this.$validator.validate();
        if (!isValid || !this.validateExpirySettings() || !this.validateReminderSettings()) {
          return;
        }
      } catch (error) {
        this.$log('Validation failed', error);
        return;
      }

      this.submitIsLoading = true;
      try {
        await DocuSignConfigurationService.updateSettingsConfigurationAsync(this.documentTypeId, this.settings);
        this.resetValidation();
        SnotifyConfiguration.showSuccess('Settings updated successfully.');
      } catch (error) {
        this.hasError = true;
        this.$log('Failed to update settings');
      } finally {
        this.submitIsLoading = false;
      }
    },
    validateExpirySettings(this: any): boolean {
      this.resetFormValidation();
      if (!this.settings.expiryEnabled) {
        return true;
      }

      if (this.expireAfterDays < this.beforeExpiryWarningDays) {
        this.addFormValidationError('Expire After Days is less than Days Before Expiry Warnings. Warnings cannot be sent after expiry');
        return false;
      }
      return true;
    },
    validateReminderSettings(this: any) {
      this.resetFormValidation();
      if (!this.settings.remindersEnabled || !this.settings.expiryEnabled) {
        return true;
      }

      if (this.expireAfterDays <= this.reminderDelayDays) {
        this.addFormValidationError('Reminder Delay Days must be less than Expire After Days. Reminders cannot be sent after expiry');
        return false;
      }

      if (this.expireAfterDays <= this.reminderFrequencyDays) {
        this.addFormValidationError('Reminder Frequency Days must be less than Expire After Days. Reminders cannot be sent after expiry');
        return false;
      }

      return true;
    },
    resetValidation(this: any) {
      this.$validator.reset();
      this.resetFormValidation();
    },
    async getData(documentTypeId: number | undefined) {
      this.isLoading = true;
      this.hasError = false;
      this.resetValidation();

      try {
        const settingsConfigurationModel = await DocuSignConfigurationService.getSettingsConfigurationAsync({
          documentTypeId
        } as DocuSignSettingsSearchModel);
        this.documentTypes = settingsConfigurationModel.documentTypes;
        if (settingsConfigurationModel.settings) {
          this.documentTypeId = settingsConfigurationModel.documentTypeId;
          this.settings = settingsConfigurationModel.settings;
          this.resetValidation();
        }
      } catch (error) {
        this.$validator.errors.add({
          field: FormFieldValidation.Constants.FormsValidationErrorsField,
          msg: error.notification
        });
      } finally {
        this.isLoading = false;
      }
    },
    initialise() {
      this.getData(undefined);
    }
  },
  watch: {
    async documentTypeId(this: any, documentTypeId: number | undefined, previousDocumentTypeId) {
      if (previousDocumentTypeId == null) {
        return;
      }
      this.getData(documentTypeId);
    }
  },
  computed: {
    haveDocuSignDocumentType(this: any) {
      return this.documentTypes?.length > 0;
    },
    expireAfterDays(this: any) {
      return Number(this.settings.expireAfterDays);
    },
    beforeExpiryWarningDays(this: any) {
      return Number(this.settings.beforeExpiryWarningDays);
    },
    reminderDelayDays(this: any) {
      return Number(this.settings.reminderDelayDays);
    },
    reminderFrequencyDays(this: any) {
      return Number(this.settings.reminderFrequencyDays);
    }
  },
  mounted(this: any) {
    this.initialise();
  },
  components: {
    MStoreFormSelect,
    LoadingSpinner
  },
  created(this: any) {
    this.daysValidation = {
      required: true,
      valueType: ValueType.Integer,
      minValue: 0,
      maxValue: 365
    } as ValidationModel;
  }
});
